import { Label } from './';
import { colorByGender } from './common';

import React from 'react';
import PropTypes from 'prop-types';

const AgeGroupLabel = ({ ageGroup, ...props }) => (
  <Label color={colorByGender(ageGroup.gender)} {...props}>
    {ageGroup.title}
  </Label>
);

AgeGroupLabel.propTypes = {
  ageGroup: PropTypes.shape({
    gender: PropTypes.shape({
      letter: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default AgeGroupLabel;



// WEBPACK FOOTER //
// ./src/components/AgeGroupLabel.js